module.exports = __webpack_public_path__ + "static/background-2-c118e962e9f132e6055d4679a5b494f1.jpg";